var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.051,
    height: 17.401,
    viewBox: "0 0 13.051 17.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-marker-alt",
    "data-name": "Icon awesome-map-marker-alt",
    d: "M5.855,17.05C.917,9.891,0,9.157,0,6.526a6.526,6.526,0,0,1,13.051,0c0,2.631-.917,3.366-5.855,10.525a.816.816,0,0,1-1.341,0Zm.671-7.806A2.719,2.719,0,1,0,3.807,6.526,2.719,2.719,0,0,0,6.526,9.244Z",
    fill: "#2b74ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlueIcon);
export default __webpack_public_path__ + "static/media/location_blue_icon.394a279a09e616511a4d7492da8308aa.svg";
export { ForwardRef as ReactComponent };